import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import api from '../../services/api';
const SmsHistory = ({ direction = 'outgoing' }) => {
  const [stats, setStats] = useState({ summary: {}, details: [] });
  const [loading, setLoading] = useState(false);
  const [period, setPeriod] = useState('today');
  const [bNumber, setBNumber] = useState('');
  useEffect(() => {
    loadStats();
  }, [period, direction]);
  const loadStats = async () => {
    setLoading(true);
    try {
      const endpoint = direction === 'outgoing' ? '/statistics/sms-outgoing' : '/statistics/sms-incoming';
      const params = new URLSearchParams({ period, b_number: bNumber });
      const response = await api.get(`${endpoint}?${params}`);
      setStats(response.data);
    } catch (error) {
      console.error('Failed to load stats:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleSearch = () => {
    loadStats();
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleString('en-GB', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric', 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };
  const { summary, details } = stats;
  return (
    <Container className="mt-4">
      <Card>
        <Card.Header>
          <h4>SMS history {direction}, today is {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long' })}</h4>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label>B number:</Form.Label>
                <Form.Control type="text" placeholder="Enter B number" value={bNumber} onChange={(e) => setBNumber(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={9}>
              <div className="d-flex gap-2 flex-wrap" style={{marginTop: '28px'}}>
                <Button size="sm" variant={period === 'last_hour' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('last_hour')}>Last Hour</Button>
                <Button size="sm" variant={period === 'today' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('today')}>Today</Button>
                <Button size="sm" variant={period === 'yesterday' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('yesterday')}>Yesterday</Button>
                <Button size="sm" variant={period === 'day_2' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('day_2')}>05 November</Button>
                <Button size="sm" variant={period === 'day_3' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('day_3')}>04 November</Button>
                <Button size="sm" variant={period === 'day_4' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('day_4')}>03 November</Button>
                <Button size="sm" variant={period === 'day_5' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('day_5')}>02 November</Button>
                <Button size="sm" variant={period === 'day_6' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('day_6')}>01 November</Button>
                <Button size="sm" variant={period === 'day_7' ? 'primary' : 'outline-primary'} onClick={() => setPeriod('day_7')}>31 October</Button>
              </div>
            </Col>
          </Row>
          {loading ? (
            <div className="text-center p-5">
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              <div className="bg-success text-white p-3 mb-3 rounded">
                <Row>
                  <Col md={4}>
                    <strong>Good/Total SMS:</strong> {summary.nzero_total || '0/0'}
                  </Col>
                  <Col md={4}>
                    <strong>Charge:</strong> {summary.client_cost || summary.vendor_cost || '0.00'}$
                  </Col>
                  <Col md={4}>
                    <strong>DLR:</strong> {summary.dlr || '0%'}
                  </Col>
                </Row>
              </div>
              {details.length > 0 ? (
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>User number</th>
                      <th>Date</th>
                      <th>Rate,$</th>
                      <th>State</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details.map((sms, idx) => (
                      <tr key={idx}>
                        <td>+{sms.dst_addr}</td>
                        <td>{formatDate(sms.add_date)}</td>
                        <td>{parseFloat(sms.cl_price || sms.pr_price || 0).toFixed(5)} $</td>
                        <td>{sms.delivery_reason || 'Unknown'}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center text-muted p-4">No SMS yet</div>
              )}
              <div className="text-muted small mt-3">
                * Time of SDR is set according to GMT0 time zone
              </div>
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};
export default SmsHistory;